
const frameColorsMap = {
    Black: "#4d4d4d",
    White: "#d2d2d2",
    Biege: "#d8b384",
    Brown: "#512809",
};

export { frameColorsMap };